import React, { useState } from 'react';
import { FaStar, FaRegStar } from 'react-icons/fa';

const Stars = ({ value, onChoose }) => {
  const [rating, setRating] = useState(value);
  const [wasChanged, setWasChanged] = useState(value > 1);

  const handleStarClick = (selectedRating) => {
    setRating(selectedRating);
    onChoose(selectedRating);
    setWasChanged(true);
  };
  return (
    <div className="search-widget stars">
      <div className={`search-field ${wasChanged}`}>
        <div className="search-preview-header">
          КЛАСС ОТЕЛЯ <b>{value}*</b> (И ЛУЧШЕ)
        </div>
        <div className="search-preview-data">
          {[1, 2, 3, 4, 5].map((number) => (
            <span key={number} onClick={() => handleStarClick(number)}>
              {rating >= number ? (
                <FaStar style={{ color: '#fb089b' }} />
              ) : (
                <FaRegStar style={{ color: '#3e93d8' }} />
              )}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Stars;
